module.exports = function() {
  return new Worker(__webpack_public_path__ + "9e06b8d12ac96ae7e9a6.worker.js");
};